export const storeRoute = (pathName: string) => {
  sessionStorage.setItem("ROUTE_BEFORE_AUTH", pathName);
};
